import { listItemButtonClasses, listItemIconClasses } from '@mui/material';

import type { SxProp } from 'src/types/mui';

export const topbarStyles: SxProp = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
};

export const topbarLeftContentStyles: SxProp = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
};

export const mobileTopbarLeftContentStyles: SxProp = {
  display: 'flex',
  alignItems: 'center',
  gap: '2px',
};

export const topbarRightContentStyles: SxProp = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  height: '100%',
};

export const popoverContentStyles: SxProp = {
  width: 280,
};

export const popoverContentTitleBoxStyles: SxProp = {
  display: 'flex',
  alignItems: 'center',
  paddingTop: 2.5,
  paddingBottom: 0,
  paddingX: 2.5,
  gap: 2,
};

export const popoverListStyles: SxProp = {
  mt: 1,
  paddingBottom: 0,

  [`.${listItemButtonClasses.root}`]: {
    paddingX: 2.5,
  },
  [`.${listItemIconClasses.root}`]: {
    minWidth: 42,
    color: 'inherit',
  },
};

export const signOutButtonStyles: SxProp = theme => ({
  color: theme.palette.red?.[500],
});

export const logoStyles: SxProp = {
  paddingLeft: '10px',
  paddingRight: '10px',
  maxWidth: '220px',
};

export const returnBtnIconStyles: SxProp = {
  width: '35px',
  height: '35px',
};

export const returnBtnStyles: SxProp = {
  padding: 0,
};
